import axios from "axios";

import { Customer_API } from "./config";

export const endpoints = {
  BarcodeCouponBook: "BarcodeCouponBook",
  Customer: "Customer",
  Territory: "Territory",
  Route: "Route",
  Supervisor: "Employee",
  Street: "Street",
  PaymentTerms: "PaymentTerms",
  ZulalCustomerImport: "ZulalCustomerImport",
  getCustomersByAreaId: "v1/customer",
};

export const CustomerAPIEndpoint = (endpoint) => {
  let url = Customer_API + "api/" + endpoint + "/";

  return {
    //Customer EndPoints
    getAll: () => axios.get(url),
    getById: (id) => axios.get(url + id),
    getByName: (name) => axios.get(url + `CustomerName?CustomerName=${name}`),
    getByPhone: (phone) =>
      axios.get(url + `CustomerPhone?PhoneNumber=${phone}`),
    getByEmail: (email) => axios.get(url + `CustomerEmail?Email=${email}`),
    getByCustomerCode: (code) => axios.get(url + `CustomerCode?CCode=${code}`),

    //BarcodeCouponBook EndPoints
    getBySerialNumber: (serialNumber) => axios.get(url + serialNumber),
    getSNByCustomerIdAndHistory: (customerId, historybyMonths) =>
      axios.get(url + customerId + historybyMonths),

    //EndPoints required for AddCustomer method
    getCustomersByAreaId: (areaId) =>
      axios.get(url + `getCustomersByGroupCode?areaId=${areaId}`),

    getAllGroups: () => axios.get(url + "CustomerGroup"),

    //Territory EndPoints

    getAllTerritories: () => axios.get(url + "TerritoryWithEmployee"),

    //Route EndPoints
    getRouteByTerritory: (territoryId) =>
      axios.get(url + `RouteByTerritory?territoryId=${territoryId}`),

    //RouteByTerritory?territoryId=59

    // Employee EndPoints
    getSupervisorByTerritory: (territoryId) =>
      axios.get(url + `GetSupervisorByTerritoryID?territoryId=${territoryId}`),

    //Street EndPoints
    getAllStreets: () => axios.get(url),

    //Payment Terms EndPoints
    getPaymentTerms: () => axios.get(url + "PaymentTerms"),

    //Zulal Customer Import EndPoint
    postZulalCustomerImport: (newcustomer) => axios.post(url, newcustomer),
  };
};
